import { useEffect } from "react";

export const SITE_URL = "https://datorra.in";
const DEFAULT_OG = `${SITE_URL}/og-cover.jpg`;

function upsertMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs.create || {}).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute("content", attrs.content);
  return el;
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
  return el;
}

function upsertJsonLd(id, data) {
  let el = document.head.querySelector(`script[data-jsonld="${id}"]`);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-jsonld", id);
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
  return el;
}

export function useSeo({ title, description, path = "/", ogImage = DEFAULT_OG, jsonLd = [] }) {
  const jsonLdKey = JSON.stringify(jsonLd);
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      upsertMeta('meta[name="description"]', { content: description, create: { name: "description" } });
      upsertMeta('meta[property="og:description"]', { content: description, create: { property: "og:description" } });
      upsertMeta('meta[name="twitter:description"]', { content: description, create: { name: "twitter:description" } });
    }
    if (title) {
      upsertMeta('meta[property="og:title"]', { content: title, create: { property: "og:title" } });
      upsertMeta('meta[name="twitter:title"]', { content: title, create: { name: "twitter:title" } });
    }
    const canonical = `${SITE_URL}${path === "/" ? "/" : path}`;
    upsertLink("canonical", canonical);
    upsertMeta('meta[property="og:url"]', { content: canonical, create: { property: "og:url" } });
    upsertMeta('meta[property="og:type"]', { content: "website", create: { property: "og:type" } });
    upsertMeta('meta[property="og:site_name"]', { content: "Datorra India", create: { property: "og:site_name" } });
    upsertMeta('meta[property="og:image"]', { content: ogImage, create: { property: "og:image" } });
    upsertMeta('meta[name="twitter:card"]', { content: "summary_large_image", create: { name: "twitter:card" } });
    upsertMeta('meta[name="twitter:image"]', { content: ogImage, create: { name: "twitter:image" } });

    // JSON-LD blocks: replace all page-scoped ones each render
    const managedIds = new Set(jsonLd.map((b) => b.id));
    document.head.querySelectorAll('script[data-jsonld][data-scope="page"]').forEach((s) => {
      if (!managedIds.has(s.getAttribute("data-jsonld"))) s.remove();
    });
    jsonLd.forEach((b) => {
      const el = upsertJsonLd(b.id, b.data);
      el.setAttribute("data-scope", "page");
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, ogImage, jsonLdKey]);
}
